// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"21e395ca","186":"05d80b6d","272":"8742cc0a","372":"28330725","738":"f205e2b7","841":"f5c8eb9a","851":"d3c0f387","856":"a9e259ee"}[chunkId] + ".chunk.js";
};